"use strict";

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryGraph = exports.postForm = exports.fetchPipe = exports.fetchBuffer = exports.fetchJson = exports.Fetcher = void 0;

var ms_1 = __importDefault(require("ms"));

var abort_controller_1 = __importDefault(require("abort-controller"));

var timers_1 = require("timers");

var Helper_1 = require("./Helper");

var blob_to_buffer_1 = __importDefault(require("blob-to-buffer"));

var cross_fetch_1 = __importDefault(require("cross-fetch"));

var FetcherConfiguration_1 = require("./FetcherConfiguration");

var Fetcher = /*#__PURE__*/function () {
  function Fetcher(customDefaults) {
    _classCallCheck(this, Fetcher);

    this.customDefaults = customDefaults !== null && customDefaults !== void 0 ? customDefaults : {};
  }

  _createClass(Fetcher, [{
    key: "fetchJson",
    value: function fetchJson(url, options) {
      return _fetchJson(url, Helper_1.mergeRequestOptions(this.customDefaults, options));
    }
  }, {
    key: "fetchBuffer",
    value: function fetchBuffer(url, options) {
      return _fetchBuffer(url, Helper_1.mergeRequestOptions(this.customDefaults, options));
    }
    /**
     * Fetches the url and pipes the response obtained from the upstream to the `writeTo` Stream and
     *  returns the headers from the upstream request.
     * @param url to request
     * @param writeTo the stream to pipe the response to
     * @param options config for the request
     */

  }, {
    key: "fetchPipe",
    value: function fetchPipe(url, writeTo, options) {
      return _fetchPipe(url, writeTo, Helper_1.mergeRequestOptions(this.customDefaults, options));
    }
  }, {
    key: "postForm",
    value: function postForm(url, options) {
      return _postForm(url, Helper_1.mergeRequestOptions(this.customDefaults, options));
    }
  }, {
    key: "queryGraph",
    value: function queryGraph(url, query, variables, options) {
      return _queryGraph(url, query, variables, Helper_1.mergeRequestOptions(this.customDefaults, options));
    }
  }]);

  return Fetcher;
}();

exports.Fetcher = Fetcher;

function _fetchJson(_x, _x2) {
  return _fetchJson2.apply(this, arguments);
}

function _fetchJson2() {
  _fetchJson2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(url, options) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", fetchInternal(url, function (response) {
              return response.json();
            }, Helper_1.mergeRequestOptions(FetcherConfiguration_1.FETCH_JSON_DEFAULTS, options)));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _fetchJson2.apply(this, arguments);
}

exports.fetchJson = _fetchJson;

function _fetchBuffer(_x3, _x4) {
  return _fetchBuffer2.apply(this, arguments);
}

function _fetchBuffer2() {
  _fetchBuffer2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(url, options) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", fetchInternal(url, function (response) {
              return extractBuffer(response);
            }, Helper_1.mergeRequestOptions(FetcherConfiguration_1.FETCH_BUFFER_DEFAULTS, options)));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _fetchBuffer2.apply(this, arguments);
}

exports.fetchBuffer = _fetchBuffer;
/**
 * Fetches the url and pipes the response obtained from the upstream to the `writeTo` Stream and
 *  returns the headers from the upstream request.
 * @param url to request
 * @param writeTo the stream to pipe the response to
 * @param options config for the request
 */

function _fetchPipe(_x5, _x6, _x7) {
  return _fetchPipe2.apply(this, arguments);
}

function _fetchPipe2() {
  _fetchPipe2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(url, writeTo, options) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", fetchInternal(url, function (response) {
              return copyResponse(response, writeTo);
            }, Helper_1.mergeRequestOptions(FetcherConfiguration_1.FETCH_BUFFER_DEFAULTS, options)));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _fetchPipe2.apply(this, arguments);
}

exports.fetchPipe = _fetchPipe;

function copyResponse(_x8, _x9) {
  return _copyResponse.apply(this, arguments);
}

function _copyResponse() {
  _copyResponse = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(response, writeTo) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            // The method pipeTo() is not working, so we need to use pipe() which is the one implemented
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            response.body.pipe(writeTo);
            return _context4.abrupt("return", response.headers);

          case 2:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _copyResponse.apply(this, arguments);
}

function _postForm(_x10, _x11) {
  return _postForm2.apply(this, arguments);
}

function _postForm2() {
  _postForm2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, options) {
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", fetchInternal(url, function (response) {
              return response.json();
            }, Helper_1.mergeRequestOptions(FetcherConfiguration_1.POST_DEFAULTS, options)));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _postForm2.apply(this, arguments);
}

exports.postForm = _postForm;

function _queryGraph(_x12, _x13, _x14, _x15) {
  return _queryGraph2.apply(this, arguments);
}

function _queryGraph2() {
  _queryGraph2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url, query, variables, options) {
    var response;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _postForm(url, Object.assign({
              body: JSON.stringify({
                query: query,
                variables: variables
              }),
              headers: {
                'Content-Type': 'application/json'
              }
            }, options));

          case 2:
            response = _context6.sent;

            if (!response.errors) {
              _context6.next = 5;
              break;
            }

            throw new Error("Error querying graph. Reasons: ".concat(JSON.stringify(response.errors)));

          case 5:
            return _context6.abrupt("return", response.data);

          case 6:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _queryGraph2.apply(this, arguments);
}

exports.queryGraph = _queryGraph;

function fetchInternal(_x16, _x17, _x18) {
  return _fetchInternal.apply(this, arguments);
}

function _fetchInternal() {
  _fetchInternal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(url, responseConsumer, options) {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            return _context8.abrupt("return", Helper_1.retry( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var controller, timeout, response, responseText;
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      controller = new abort_controller_1.default();
                      timeout = timers_1.setTimeout(function () {
                        controller.abort();
                      }, ms_1.default(options.timeout));
                      _context7.prev = 2;
                      _context7.next = 5;
                      return cross_fetch_1.default(url, {
                        signal: controller.signal,
                        body: options.body,
                        method: options.method,
                        headers: options.headers
                      });

                    case 5:
                      response = _context7.sent;

                      if (!response.ok) {
                        _context7.next = 12;
                        break;
                      }

                      _context7.next = 9;
                      return responseConsumer(response);

                    case 9:
                      return _context7.abrupt("return", _context7.sent);

                    case 12:
                      _context7.next = 14;
                      return response.text();

                    case 14:
                      responseText = _context7.sent;
                      throw new Error("Failed to fetch ".concat(url, ". Got status ").concat(response.status, ". Response was '").concat(responseText, "'"));

                    case 16:
                      _context7.prev = 16;
                      timers_1.clearTimeout(timeout);
                      return _context7.finish(16);

                    case 19:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7, null, [[2,, 16, 19]]);
            })), options.attempts, options.waitTime));

          case 1:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchInternal.apply(this, arguments);
}

function extractBuffer(_x19) {
  return _extractBuffer.apply(this, arguments);
}

function _extractBuffer() {
  _extractBuffer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(response) {
    var blob;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            if (!('buffer' in response)) {
              _context9.next = 2;
              break;
            }

            return _context9.abrupt("return", response.buffer());

          case 2:
            _context9.next = 4;
            return response.blob();

          case 4:
            blob = _context9.sent;
            return _context9.abrupt("return", asyncBlobToBuffer(blob));

          case 6:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _extractBuffer.apply(this, arguments);
}

function asyncBlobToBuffer(blob) {
  return new Promise(function (resolve, reject) {
    blob_to_buffer_1.default(blob, function (err, buffer) {
      if (err) reject(err);
      resolve(buffer);
    });
  });
}